module.exports = __webpack_public_path__ + "assets/images/pages/workshops/succes-form.png?c615a24c";